import { ComponentSettings, FieldTypes } from "../settings/settings";

const field = {
  bavFv: {
    type: FieldTypes.userOptions,
    text: {
      de: "BAV-Fernverkehr",
      en: "BAV-Fernverkehr",
    },
    search: false,
    multiple: false,
  },
  bavFvEmail: {
    type: FieldTypes.options,
    text: {
      de: "BAV-Fernverkehr",
      en: "BAV-Fernverkehr",
    },
    search: false,
  },
  bavFvVertreter: {
    type: FieldTypes.userOptions,
    text: {
      de: "Vertreter",
      en: "Deputy",
    },
    search: false,
  },
  bavFvVertreterEmail: {
    type: FieldTypes.value,
    text: {
      de: "BAV-Fernverker Vertreter",
      en: "BAV-Fernverker Vertreter",
    },
    search: false,
  },
  bavFvVertreter2: {
    type: FieldTypes.userOptions,
    text: {
      de: "Zweiter Vertreter der BAV FV",
      en: "BAV FV Second Deputy",
    },
    search: false,
  },
  bavFvVertreter2Email: {
    type: FieldTypes.value,
    text: {
      de: "Zweiter Vertreter der BAV FV Email",
      en: "BAV FV Second Deputy Email",
    },
    search: false,
  },
  mawiFv: {
    type: FieldTypes.userOptions,
    text: {
      de: "MaWi-Fernverkehr",
      en: "MaWi-Fernverkehr",
    },
    search: false,
  },
  mawiFvEmail: {
    type: FieldTypes.options,
    text: {
      de: "MaWi-Fernverkehr",
      en: "MaWi-Fernverkehr",
    },
    search: false,
  },
  mawiFvVertreter: {
    type: FieldTypes.userOptions,
    text: {
      de: "Vertreter",
      en: "Deputy",
    },
    search: false,
  },
  mawiFvVertreterEmail: {
    type: FieldTypes.options,
    text: {
      de: "MaWi FV Vertreter",
      en: "MaWi FV Vertreter",
    },
    search: false,
  },
  mawiFvVertreter2: {
    type: FieldTypes.userOptions,
    text: {
      de: "Zweiter Vertreter der MaWi FV",
      en: "MaWi FV Second Deputy",
    },
    search: false,
  },
  mawiFvVertreter2Email: {
    type: FieldTypes.value,
    text: {
      de: "Zweiter Vertreter der MaWi FV Email",
      en: "MaWi FV Second Deputy Email",
    },
    search: false,
  },
  bavRegio: {
    type: FieldTypes.userOptions,
    text: {
      de: "BAV Regio",
      en: "BAV Regio",
    },
    search: false,
  },
  bavRegioEmail: {
    type: FieldTypes.options,
    text: {
      de: "BAV Regio",
      en: "BAV Regio",
    },
    search: false,
  },
  bavRegioVertreter: {
    type: FieldTypes.userOptions,
    text: {
      de: "Vertreter",
      en: "Deputy",
    },
    search: false,
  },
  bavRegioVertreterEmail: {
    type: FieldTypes.userOptions,
    text: {
      de: "BAV Regio Vertreter",
      en: "BAV Regio Vertreter",
    },
    search: false,
  },
  bavRegioVertreter2: {
    type: FieldTypes.userOptions,
    text: {
      de: "Zweiter Vertreter der BAV Regio",
      en: "BAV Regio Second Deputy",
    },
    search: false,
  },
  bavRegioVertreter2Email: {
    type: FieldTypes.value,
    text: {
      de: "Zweiter Vertreter der BAV Regio Email",
      en: "BAV Regio Second Deputy Email",
    },
    search: false,
  },
  mawiRegio: {
    type: FieldTypes.userOptions,
    text: {
      de: "MaWi Regio",
      en: "MaWi Regio",
    },
    search: false,
  },
  mawiRegioEmail: {
    type: FieldTypes.options,
    text: {
      de: "MaWi Regio",
      en: "MaWi Regio",
    },
    search: false,
  },
  mawiRegioVertreter: {
    type: FieldTypes.userOptions,
    text: {
      de: "Vertreter",
      en: "Deputy",
    },
    search: false,
  },
  mawiRegioVertreterEmail: {
    type: FieldTypes.options,
    text: {
      de: "MaWi Regio Vertreter",
      en: "MaWi Regio Vertreter",
    },
    search: false,
  },
  mawiRegioVertreter2: {
    type: FieldTypes.userOptions,
    text: {
      de: "Zweiter Vertreter der MaWi Regio",
      en: "MaWi Regio Second Deputy",
    },
    search: false,
  },
  mawiRegioVertreter2Email: {
    type: FieldTypes.value,
    text: {
      de: "Zweiter Vertreter der MaWi Regio Email",
      en: "MaWi Regio Second Deputy Email",
    },
    search: false,
  },
  bavCargo: {
    type: FieldTypes.userOptions,
    text: {
      de: "BAB Cargo",
      en: "BAB Cargo",
    },
    search: false,
  },
  bavCargoEmail: {
    type: FieldTypes.options,
    text: {
      de: "BAB Cargo",
      en: "BAB Cargo",
    },
    search: false,
  },
  bavCargoVertreter: {
    type: FieldTypes.userOptions,
    text: {
      de: "BAV Cargo",
      en: "BAV Cargo",
    },
    search: false,
  },
  bavCargoVertreterEmail: {
    type: FieldTypes.options,
    // text: {
    //   de: "BAV Cargo",
    //   en: "BAV Cargo",
    // },
    text: {
      de: "Vertreter",
      en: "Deputy",
    },
    search: false,
  },
  bavCargoVertreter2: {
    type: FieldTypes.userOptions,
    text: {
      de: "Zweiter Vertreter der BAV Cargo",
      en: "BAV Cargo Second Deputy",
    },
    search: false,
  },
  bavCargoVertreter2Email: {
    type: FieldTypes.value,
    text: {
      de: "Zweiter Vertreter der BAV Cargo Email",
      en: "BAV Cargo Second Deputy Email",
    },
    search: false,
  },
  mawiCargo: {
    type: FieldTypes.userOptions,
    text: {
      de: "MaWi Cargo",
      en: "MaWi Cargo",
    },
    search: false,
  },
  mawiCargoEmail: {
    type: FieldTypes.options,
    text: {
      de: "MaWi Cargo",
      en: "MaWi Cargo",
    },
    search: false,
  },
  mawiCargoVertreter: {
    type: FieldTypes.userOptions,
    text: {
      de: "Vertreter",
      en: "Deputy",
    },
    search: false,
  },
  mawiCargoVertreterEmail: {
    type: FieldTypes.options,
    text: {
      de: "MaWi Cargo Vertreter",
      en: "MaWi Cargo Vertreter",
    },
    search: false,
  },
  mawiCargoVertreter2: {
    type: FieldTypes.userOptions,
    text: {
      de: "Zweiter Vertreter der MaWi Cargo",
      en: "MaWi Cargo Second Deputy",
    },
    search: false,
  },
  mawiCargoVertreter2Email: {
    type: FieldTypes.value,
    text: {
      de: "Zweiter Vertreter der MaWi Cargo Email",
      en: "MaWi Cargo Second Deputy Email",
    },
    search: false,
  },
  bavFzi: {
    type: FieldTypes.userOptions,
    text: {
      de: "BAV (Drittkunden)",
      en: "BAV (Drittkunden)",
    },
    search: false,
  },
  bavFziEmail: {
    type: FieldTypes.options,
    text: {
      de: "BAV (Drittkunden)",
      en: "BAV (Drittkunden)",
    },
    search: false,
  },
  bavFziVertreter: {
    type: FieldTypes.userOptions,
    text: {
      de: "Vertreter",
      en: "Deputy",
    },
    search: false,
  },
  bavFziVertreterEmail: {
    type: FieldTypes.options,
    text: {
      de: "BAV FZI Vertreter",
      en: "BAV FZI Vertreter",
    },
    search: false,
  },
  bavFziVertreter2: {
    type: FieldTypes.userOptions,
    text: {
      de: "Zweiter Vertreter der BAV FZI",
      en: "BAV FZI Second Deputy",
    },
    search: false,
  },
  bavFziVertreter2Email: {
    type: FieldTypes.value,
    text: {
      de: "Zweiter Vertreter der BAV FZI Email",
      en: "BAV FZI Second Deputy Email",
    },
    search: false,
  },
  mawiFzi: {
    type: FieldTypes.userOptions,
    text: {
      de: "MaWi FZI",
      en: "MaWi FZI",
    },
    search: false,
  },
  mawiFziEmail: {
    type: FieldTypes.options,
    text: {
      de: "MaWi FZI",
      en: "MaWi FZI",
    },
    search: false,
  },
  mawiFziVertreter: {
    type: FieldTypes.userOptions,
    text: {
      de: "Vertreter",
      en: "Deputy",
    },
    search: false,
  },
  mawiFziVertreterEmail: {
    type: FieldTypes.options,
    text: {
      de: "MaWi Fzi Vertreter",
      en: "MaWi Fzi Vertreter",
    },
    search: false,
  },
  mawiFziVertreter2: {
    type: FieldTypes.userOptions,
    text: {
      de: "Zweiter Vertreter der MaWi FZI",
      en: "MaWi FZI Second Deputy",
    },
    search: false,
  },
  mawiFziVertreter2Email: {
    type: FieldTypes.value,
    text: {
      de: "Zweiter Vertreter der MaWi FZI Email",
      en: "MaWi FZI Second Deputy Email",
    },
    search: false,
  },
  bavNetz: {
    type: FieldTypes.userOptions,
    text: {
      de: "BAV Sonstige",
      en: "BAV Sonstige",
    },
    search: false,
  },
  bavNetzEmail: {
    type: FieldTypes.options,
    text: {
      de: "BAV Sonstige",
      en: "BAV Sonstige",
    },
    search: false,
  },
  bavNetzVertreter: {
    type: FieldTypes.userOptions,
    text: {
      de: "Vertreter",
      en: "Deputy",
    },
    search: false,
  },
  bavNetzVertreterEmail: {
    type: FieldTypes.options,
    text: {
      de: "BAV Sonstige Vertreter",
      en: "BAV Sonstige Vertreter",
    },
    search: false,
  },
  bavNetzVertreter2: {
    type: FieldTypes.userOptions,
    text: {
      de: "Zweiter Vertreter der BAV Sonstige",
      en: "BAV Sonstige Second Deputy",
    },
    search: false,
  },
  bavNetzVertreter2Email: {
    type: FieldTypes.value,
    text: {
      de: "Zweiter Vertreter der BAV Sonstige Email",
      en: "BAV Sonstige Second Deputy Email",
    },
    search: false,
  },
  mawiNetz: {
    type: FieldTypes.userOptions,
    text: {
      de: "MaWi Sonstige",
      en: "MaWi Sonstige",
    },
    search: false,
  },
  mawiNetzEmail: {
    type: FieldTypes.options,
    text: {
      de: "MaWi Sonstige",
      en: "MaWi Sonstige",
    },
    search: false,
  },
  mawiNetzVertreter: {
    type: FieldTypes.userOptions,
    text: {
      de: "Vertreter",
      en: "Deputy",
    },
    search: false,
  },
  mawiNetzVertreterEmail: {
    type: FieldTypes.options,
    text: {
      de: "MaWi Sonstige Vertreter",
      en: "MaWi Sonstige Vertreter",
    },
    search: false,
  },
  mawiNetzVertreter2: {
    type: FieldTypes.userOptions,
    text: {
      de: "Zweiter Vertreter der MaWi Sonstige",
      en: "MaWi Sonstige Second Deputy",
    },
    search: false,
  },
  mawiNetzVertreter2Email: {
    type: FieldTypes.value,
    text: {
      de: "Zweiter Vertreter der MaWi Sonstige Email",
      en: "MaWi Sonstige Second Deputy Email",
    },
    search: false,
  },
  responsibles: {
    type: FieldTypes.value,
    text: {
      de: "Fahrzeug verantwortlich",
      en: "Vehicle Responsible",
      nl: "Voertuig verantwoordelijk",
    },
  },
};

export const settings = {
  permission: {},
  text: {
    department: { de: "Abteilung", en: "Department", nl: "Afdeling" },
    completeTask: {
      de: "KOMPLETTE AUFGABE",
      en: "COMPLETE TASK",
      nl: "VOLTOOIDE TAAK",
    },
  },
  url: {},
  field,
  list: {},
  additionalInfo: {},
};

export const responsibles: ComponentSettings<typeof settings> = settings;
